export enum SigmaOLMSStyles {
  FIBRE_IPE = "FibreIPE",
  FIBRE_IPE_CLIENT = "FibreIPEClient",
  RADIO_COUVERTURE_AMENAGEURS = "RadioCouvertureAmenageurs",
  SIGMA_POI_ADP = "SigmaPoiADP",
  SIGMA_POI_ADP_CLIENT = "SigmaPoiADPClient"
}
